module.exports = __webpack_public_path__ + "img/guide-hover.22805b25.svg";